/** @jsx jsx */
import { TextInput, TextInputProps } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { IFilterComponentProps, useOnChangeFilterHandler } from "@/infrastructure/Filter";

interface TextFilterProps extends IFilterComponentProps<string>, Omit<TextInputProps, keyof IFilterComponentProps> {}

export const TextFilter: FC<TextFilterProps> = ({ name, onChange, ...rest }) => {
  const handleChange = useOnChangeFilterHandler(name, onChange);

  return <TextInput type="text" name={name} onChange={handleChange} {...rest} />;
};
